import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import { Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { ReceiptCheckItem } from "../../../../../../../domain/models/receipt-check";

type Props = {
  item: ReceiptCheckItem;
  onClick: (id: number) => void;
};

export const ProductCard: React.FC<Props> = ({ onClick, item }) => {
  const getStatus = (): "Não Iniciada" | "Em Andamento" | "Finalizada" => {
    if (item.countedAmount === item.storedAmount) return "Finalizada";
    if (item.storedAmount == 0) return "Não Iniciada";
    if (item.countedAmount > item.storedAmount) return "Em Andamento";

    return "Em Andamento";
  };

  const getColor = (): "error" | "warning" | "success" => {
    if (item.countedAmount === item.storedAmount) return "success";
    if (item.storedAmount == 0) return "error";
    if (item.countedAmount > item.storedAmount) return "warning";
    return "warning";
  };
  return (
    <Paper sx={{ p: "10px" }}>
      <Stack direction="row">
        <Box
          sx={{
            width: "60%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Stack>
            <Typography fontWeight="bold" fontSize="20px">
              {item.description}
            </Typography>
            <Typography>{`Marca: ${item.supplier}`}</Typography>
            {item.batchControl ? (
              <Typography>{`Lote: ${item.batch}`}</Typography>
            ) : (
              ""
            )}
            <Typography>{`Quantidade: ${Number(
              (
                (item.countedAmount - item.storedAmount) /
                (item.packageAmount || 1)
              ).toFixed(4)
            )}`}</Typography>
          </Stack>
        </Box>
        <Box
          sx={{
            width: "40%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-around",
          }}
        >
          <Chip
            label={getStatus()}
            variant="outlined"
            color={getColor()}
            size="small"
          />
          <Button
            variant="contained"
            color="secondary"
            sx={{ color: "white" }}
            onClick={onClick.bind(null, 1)}
          >
            Iniciar
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};
